(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ravici-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const fill = (marquee) => {
      const track = marquee.querySelector('.ravici-marquee__track');
      const groups = track ? track.querySelectorAll('.ravici-marquee__group') : [];
      if (!track || !groups.length) return;
      const original = groups[0];
      const groupWidth = original.getBoundingClientRect().width;
      if (!groupWidth) return;

      track.querySelectorAll('[data-ravici-marquee-clone]').forEach((clone) => clone.remove());

      if (reduce.matches) {
        marquee.style.removeProperty('--ravici-marquee-shift');
        return;
      }

      // Enough copies to cover the viewport while one copy's width scrolls out of view.
      const needed = Math.max(2, Math.ceil(marquee.clientWidth / groupWidth) + 1);
      for (let i = 1; i < needed; i++) {
        const clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-ravici-marquee-clone', '');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        track.appendChild(clone);
      }
      marquee.style.setProperty('--ravici-marquee-shift', `${groupWidth}px`);
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-ravici-marquee]').forEach((marquee) => {
        if (marquee.dataset.raviciMarqueeReady) return;
        marquee.dataset.raviciMarqueeReady = 'true';
        fill(marquee);
        if ('ResizeObserver' in window) {
          let frame = 0;
          new ResizeObserver(() => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => fill(marquee));
          }).observe(marquee);
        }
      });
    };

    const refreshAll = () => document.querySelectorAll('[data-ravici-marquee]').forEach(fill);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refreshAll);
    reduce.addEventListener('change', refreshAll);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ravici-marquee]').forEach((m) => delete m.dataset.raviciMarqueeReady);
      init(event.target);
    });
    document.addEventListener('shopify:block:select', refreshAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ravici-video-reel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__raviciReelInit) return;
    window.__raviciReelInit = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Hosted autoplay videos: play while in view, pause when scrolled away.
    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                const tile = entry.target;
                const video = tile.querySelector('video');
                const iframe = tile.querySelector('[data-ravici-reel-iframe]');
                if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                  if (iframe && iframe.dataset.src && iframe.getAttribute('src') === 'about:blank') {
                    iframe.setAttribute('src', iframe.dataset.src);
                    tile.setAttribute('data-playing', '');
                  }
                  if (video && !reduceMotion.matches) {
                    const p = video.play();
                    if (p && typeof p.catch === 'function') p.catch(() => {});
                  }
                } else if (video && !video.paused) {
                  video.pause();
                }
              }
            },
            { threshold: [0, 0.35, 0.6] }
          )
        : null;

    const initTile = (tile) => {
      if (tile.dataset.reelReady) return;
      tile.dataset.reelReady = 'true';
      const video = tile.querySelector('video');
      if (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.addEventListener('playing', () => tile.setAttribute('data-playing', ''));
        video.addEventListener('pause', () => {
          // Keep the frame on the video (not the poster) once it has played.
        });
      }
      const autoplay = tile.closest('.ravici-reel--autoplay');
      if (autoplay && observer) observer.observe(tile);
      else if (autoplay && video && !reduceMotion.matches) {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }
    };

    const init = (root) => {
      root.querySelectorAll('[data-ravici-reel-tile]').forEach(initTile);
    };

    // Clicks: sound toggle and tap-to-play.
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const sound = target.closest('[data-ravici-reel-sound]');
      if (sound) {
        event.preventDefault();
        const tile = sound.closest('[data-ravici-reel-tile]');
        const video = tile && tile.querySelector('video');
        if (!video) return;
        const unmuting = video.muted;
        // One voice at a time: mute every other reel video.
        document.querySelectorAll('[data-ravici-reel-tile] video').forEach((v) => {
          if (v !== video) {
            v.muted = true;
            const b = v.parentElement.querySelector('[data-ravici-reel-sound]');
            if (b) {
              b.setAttribute('aria-pressed', 'false');
              b.setAttribute('aria-label', b.dataset.labelOn || 'Unmute');
            }
          }
        });
        video.muted = !unmuting;
        sound.setAttribute('aria-pressed', unmuting ? 'true' : 'false');
        sound.setAttribute('aria-label', unmuting ? sound.dataset.labelOff || 'Mute' : sound.dataset.labelOn || 'Unmute');
        if (unmuting && video.paused) {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        }
        return;
      }

      const play = target.closest('[data-ravici-reel-play]');
      if (play) {
        event.preventDefault();
        const tile = play.closest('[data-ravici-reel-tile]');
        const frame = tile && tile.querySelector('.ravici-reel__frame');
        const template = tile && tile.querySelector('[data-ravici-reel-media]');
        if (!frame || !template) return;
        // Pause any other tapped video so only one plays at a time.
        document.querySelectorAll('[data-ravici-reel-tile][data-activated] video').forEach((v) => v.pause());
        frame.insertBefore(template.content.cloneNode(true), frame.firstChild);
        template.remove();
        tile.setAttribute('data-activated', '');
        const video = frame.querySelector('video');
        if (video) {
          video.muted = false;
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
          video.focus({ preventScroll: true });
        }
      }
    });

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const tile = event.target && event.target.closest ? event.target.closest('[data-ravici-reel-tile]') : null;
      if (tile) tile.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
